
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/plan",
      function () {
        return require("private-next-pages/plan.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/plan"])
      });
    }
  